import { css, html } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { property } from "lit/decorators/property.js";
import "./card";
import { BsCard } from "./card";

@customElement("bs-list-item")
export class BsListItem extends BsCard {
	@property({ type: Boolean, reflect: true }) inline = false;
	@property({ type: Boolean, reflect: true }) wrap = false;

	static get styles() {
		return [
			...super.styles,
			css`
				:host {
					--card-color-active: var(--list-item-color-active, var(--primary-dark));
					position: relative;
					margin-left: calc(var(--space-m) * -1);
					margin-right: calc(var(--space-m) * -1);
					flex-direction: row;
					display: flex;
					align-items: center;
					gap: var(--space-s);
					flex-grow: 1;
				}

				:host([inline]) {
					display: inline-flex;
					width: auto;
					margin-left: unset;
					margin-right: unset;
					flex-grow: initial;
				}

				:host(:not([hoverable]):not([active])),
				:host(:not([active]):not(:hover)) {
					border-color: transparent;
					box-shadow: none;
					background: none;
				}

				:host([wrap]) #content {
					flex-wrap: wrap;
				}

				#content {
					display: flex;
					align-items: center;
					gap: var(--space-s);
					width: 100%;
					padding: var(--space-s) var(--space-m);
					overflow: visible;
				}

				#grower {
					flex-grow: 1;
				}
			`
		];
	}

	render() {
		return html`
			<div id="content">
				<slot></slot>
				<div id="grower"></div>
				<slot name="more"></slot>
			</div>
		`;
	}
}
